<template>
  <div class="bg-white" style="padding: 15px">
    <el-row :gutter="15">
      <el-col v-if="user.isRole(1)" :sm="12">
        <div>
          <el-upload
            class="mb-1"
            :action="api.href"
            :file-list="fileList"
            accept=".csv"
            :headers="api.headers"
            :on-success="handleSuccess"
            :show-file-list="false"
          >
            <el-button type="primary" icon="el-icon-upload" size="small"
              >Batch Upload</el-button
            >
          </el-upload>
        </div>
      </el-col>
      <el-col :sm="{ span: 12, offset: !user.isRole(1) ? 12 : 0 }">
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-select
              v-model="pager.search"
              placeholder="Search..."
              clearable
              filterable
            >
              <el-option
                v-for="s in glossary"
                :key="s.id"
                :value="s.name"
                :label="s.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="fetch(1)"
            >Search</el-button
          >
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="list.data"
      v-loading="isLoading"
      empty-text="No records found."
    >
      <el-table-column label="Actions" width="100" fixed>
        <template slot-scope="scope">
          <router-link
            class="el-button el-button--primary el-button--small is-circle"
            :to="{ name: 'supplier_info', params: { id: scope.row.id } }"
            title="View supplier information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <!-- <el-button size="small" type="primary"  icon="el-icon-folder-opened" circle></el-button> -->
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="itemDelete(scope.row.id)"
            title="Delete supplier"
            circle
            v-if="user.isRole(1)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Name" prop="name" fixed />
      <el-table-column label="Contact Person" prop="contact_person" />
      <el-table-column label="Telephone" prop="telephone" width="150" />
      <el-table-column label="Status" width="100" prop="status" />
      <el-table-column label="Date Created" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.created_at | dateFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 "
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>

<script>
import api from "@/api";
import Supplier from "@/models/Supplier";
export default {
  name: "suppliers_list",
  computed: {
    list() {
      return this.$store.getters["supplier/list"];
    },
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/suppliers/upload/", api.baseUrl).href
      };
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  data() {
    return {
      isLoading: false,
      pager: {
        limit: 25,
        search: ""
      },
      fileList: [],
      glossary: []
    };
  },
  methods: {
    itemDelete(id) {
      this.$confirm("Are you sure you want to delete this supplier?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          this.$store.dispatch("supplier/delete", id).then(resp => {
            if (!resp.msg)
              this.$notify({
                type: "danger",
                message: "Delete failed.",
                position: "bottom-right"
              });
            else
              this.$notify({
                type: "success",
                message: "Supplier deleted successfully.",
                position: "bottom-right"
              });
            this.isLoading = false;
          });
        })
        .catch(() => {});
      // this.$store.dispatch("supplier/delete", this.active.id).then(resp => {
      //   if (!resp.msg) this.$store.dispatch("alert/push", "Delete failed.");
      //   else
      //     this.$store.dispatch("alert/push", {
      //       message: "Supplier deleted successfully.",
      //       type: "success"
      //     });
      // });
    },
    fetch(page) {
      this.pager.page = page;
      this.isLoading = true;
      var params = { ...this.pager };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("supplier/getList", params).then(() => {
        this.isLoading = false;
      });
    },
    handleSuccess(resp) {
      if (resp.data.errors && resp.data.errors.length != 0) {
        console.error(resp.data.errors);
        this.$notify({
          type: "error",
          message:
            "Error encountered during processing of batch upload. Please see your browser console.",
          position: "bottom-right"
        });
      } else {
        if (resp.data.code == 200) {
          this.fetch(1);
          this.$notify({
            type: "success",
            message: "Supplier batch upload success.",
            position: "bottom-right"
          });
        } else {
          this.$notify({
            type: "error",
            message: resp.data.msg,
            position: "bottom-right"
          });
        }
      }
    }
  },
  mounted() {
    this.fetch(1);
    Supplier.getGlossary().then(list => {
      this.glossary = list;
    });
  }
};
</script>

<style lang="css" scoped></style>
